import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, MessageSquare } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

// Opens (or reuses) the chat with the assistant that produced this stage, quoting its output; a revision asked there re-runs just this stage.
export function StepChatButton({ taskId, stepId, idx }) {
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/tasks/${taskId}/discuss`, { mode: "chat", step_id: stepId });
      nav(`/chat/${r.data.conversation_id}`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal membuka chat langkah"); } finally { setBusy(false); }
  };
  return (
    <button onClick={go} disabled={busy} title="Chat langkah ini — bahas atau minta revisi dengan asistennya" aria-label="Chat langkah ini" className="rounded-lg p-1.5 text-slate-400 hover:bg-[#EEF3FF] hover:text-[#2F6BFF] disabled:opacity-60" data-testid={`step-chat-${idx}`}>
      {busy ? <Loader2 size={15} className="animate-spin" /> : <MessageSquare size={15} />}
    </button>
  );
}
